import { apiClient } from './axiosInstance';

export const fetchMembersFilterList = async () => {
  return await apiClient.get(`/members/base/members`);
};
